module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 015.7049d15b.jpg";